module.exports = __webpack_public_path__ + "static/img/元宇宙系统开发.eb3201dc.png";